<div class="login-container">
  <div class="login-container">
  <div class="login-card">
    <div class="login-header">
      <app-logo></app-logo>
      <h2 class="login-title">TaskTrackerPro</h2>
      <p class="login-subtitle">{{ 'LOGIN.TITLE' | translate }}</p>
    </div>
          <form [formGroup]="loginForm" (ngSubmit)="login()">
        <div class="form-group mb-3">
          <label for="email">{{ 'LOGIN.EMAIL' | translate }}</label>
          <input id="email" type="email" formControlName="email" class="form-control" [placeholder]="'LOGIN.EMAIL' | translate"
                 [class.is-invalid]="loginForm.get('email')?.invalid && (loginForm.get('email')?.dirty || loginForm.get('email')?.touched)">
          <div *ngIf="loginForm.get('email')?.invalid && (loginForm.get('email')?.dirty || loginForm.get('email')?.touched)" class="invalid-feedback">
            <div *ngIf="loginForm.get('email')?.hasError('required')">{{ 'FORM_ERRORS.REQUIRED' | translate }}</div>
            <div *ngIf="loginForm.get('email')?.hasError('email')">{{ 'FORM_ERRORS.EMAIL_INVALID' | translate }}</div>
          </div>
        </div>
        <div class="form-group mb-4">
          <label for="password">{{ 'LOGIN.PASSWORD' | translate }}</label>
          <input id="password" type="password" formControlName="password" class="form-control" [placeholder]="'LOGIN.PASSWORD' | translate"
                 [class.is-invalid]="loginForm.get('password')?.invalid && (loginForm.get('password')?.dirty || loginForm.get('password')?.touched)">
          <div *ngIf="loginForm.get('password')?.invalid && (loginForm.get('password')?.dirty || loginForm.get('password')?.touched)" class="invalid-feedback">
            <div *ngIf="loginForm.get('password')?.hasError('required')">{{ 'FORM_ERRORS.REQUIRED' | translate }}</div>
          </div>
        </div>
      <button type="submit" [disabled]="loginForm.invalid" class="btn btn-primary w-100">
        {{ 'LOGIN.BUTTON' | translate }}
      </button>
      <div *ngIf="errorMessage" class="alert alert-danger mt-3">
        {{ errorMessage }}
      </div>
    </form>
  </div>
</div>
</div>
